/**
 * Copyright © 2025 Farmlands Co-operative Society Limited. All rights reserved.
 *
 * This document contains confidential information and is the property of Farmlands.
 * Unauthorised reproduction or distribution of any part of this publication is prohibited without written consent.
 */

import { CalendarTodayOutlined } from "@mui/icons-material";
import { Avatar, Card, Stack, Typography } from "@mui/material";
import { FC, type JSX } from "react";

import TestIds from "../../../../testIds";

const NoActivities: FC = (): JSX.Element => {
  return (
    <Stack flex={1} alignItems="stretch">
      <Card
        variant="outlined"
        sx={{
          borderRadius: "16px",
          p: 2,
          height: "645px",
          "&.MuiPaper-outlined": { backgroundColor: "grey.100" },
        }}
        className="farmlands-v2"
        data-testid={TestIds.feat.activities.activitiesList.empty}
      >
        <Stack alignItems="center" justifyContent="center" height="100%" gap={3}>
          <Avatar color="grey.200" sx={{ width: 68, height: 68 }}>
            <CalendarTodayOutlined color="disabled" fontSize="large" />
          </Avatar>
          <Stack alignItems="center">
            <Typography fontWeight={700}>No activities</Typography>
            <Typography fontSize={16} color="grey.800">
              No activities have been created for this account yet
            </Typography>
          </Stack>
        </Stack>
      </Card>
    </Stack>
  );
};

export default NoActivities;
